<template>
  <v-card flat>
    <v-card-title class="text-h5">
      Risk map
    </v-card-title>
    <v-card-subtitle>
      This module allows you to define the spatial resolution and the untis (ha or %), and to generate the “Deforestation risk map.
      <br/>You are able to modify the resolution and units, and to recalculate the map as many times as needed.
    </v-card-subtitle>

    <v-card-text>
      <v-row>
        <!-- Input form -->
        <v-col>
          <v-card elevation="4">
            <v-card-text>
              <v-form v-model="isValid">
                <v-subheader class="pl-0 mb-6">Resolution of the generated risk map (metres)</v-subheader>
                <v-slider v-model="resolution" step="10" :min="100" :max="6000" thumb-label="always" ticks></v-slider>

                <p class="text-body-1 pt-4">Format in which the values will be represented in the risk map</p>
                <v-radio-group v-model="riskMapFormat" row>
                  <v-radio :value="0" label="ha"/>
                  <v-radio :value="1" label="Rate"/>
                </v-radio-group>
              </v-form>

              <v-btn width="150" color="primary" :disabled="!isValid" :loading="isInitProcessing" @click="process">Process</v-btn>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Results -->
        <v-col>
          <v-card elevation="4">
            <v-card-title>Results</v-card-title>

            <v-card-text>
              <vx-result-file-list :fileList="resultFiles"/>
            </v-card-text>

            <v-card-actions class="px-4">
              <!-- <v-btn color="primary" outlined>
                <v-icon left>mdi-download</v-icon>
                Download deforestation map
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

import api from '../../api'
import ResultFileList from './ResultFileList.vue'

export default {
  name: 'Module4',

  props: {
    region: Object,
    currentProcess: String
  },

  components: {
    'vx-result-file-list': ResultFileList
  },

  data: () => ({
    isValid: false,
    riskMapFormats: ['ha', 'Rate'],

    // Periodic checking
    isInitProcessing: false,
    isProcessing: false,
    intervalCall: null,
    finishedProcessing: false,

    // Input
    resolution: 100,
    riskMapFormat: 0,

    // Output
    resultFiles: []
  }),

  watch: {
    isProcessing (val) {
      this.isInitProcessing = val

      if (val && !this.intervalCall) {
        this.intervalCall = setInterval(() => {
          api.process.getResults(this.currentProcess, 4).then(response => {
            if (response.data.error) {
              this.stopProcessing()

              console.error(response.data.error)
              this.$toastr.e(response.data.message)
            } else {
              if (response.data.finished) {
                this.resultFiles = response.data.results

                // Save results in store
                this.setMod4Results(this.resultFiles)

                this.$toastr.s('Module 4 succesfully processed')

                // Ready for results
                this.finishedProcessing = true
                this.$emit('onProcessed')

                this.stopProcessing()
              } else {
                // Not finished
              }
            }
          }).catch(error => {
            this.stopProcessing()

            console.error(error)
            this.$toastr.e('Error processing module 4')
          }).finally(() => {
            // Nothing
          })
        }, 10 * 1000)
      } else {
        clearInterval(this.intervalCall)
        this.intervalCall = null
      }
    }
  },

  methods: {
    ...mapActions('app', [
      'setIsProcessing'
    ]),

    ...mapActions('currentProcess', [
      'setMod4Results'
    ]),

    stopProcessing () {
      this.isProcessing = false
      clearInterval(this.intervalCall)
      this.intervalCall = null

      this.setIsProcessing(false)
    },

    reset () {
      this.finishedProcessing = false

      // Input
      this.resolution = 100
      this.riskMapFormat = 0

      // Output
      this.resultFiles = []
    },

    async process () {
      let data = {
        processId: this.currentProcess,
        resolution: this.resolution,
        format: this.riskMapFormat === 0 ? 'ha' : 'rate'
      }

      try {
        this.setIsProcessing(true)
        this.isInitProcessing = true

        await api.process.module4(data)

        this.isProcessing = true
        this.$toastr.s('Module 4 starts processing...')
      } catch (error) {
        this.isInitProcessing = false

        console.error(error)
        this.$toastr.e('Error initializing module 4')
      }
    }
  },

  mounted () {
    this.riskMapFormat = 0
  }
}
</script>

<style scoped>

</style>
